import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const fetchVehicleTypes = async function (clientId) {
  try {
    const res = await axios.get(urls.getVehicleType + '/' + clientId)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchCustomerDetail = async function (clientId) {
  try {
    const res = await axios.get(urls.getCustomerDetail + '/' + clientId)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchBasp = async function (filters) {
  try {
    const res = await axios.get(urls.getListBasp + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetch3PLDriverRating = async function (filters) {
  try {
    const res = await axios.get(urls.get3PLDriverRating + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetch3PLTransportRating = async function (filters) {
  try {
    const res = await axios.get(urls.get3PLTransportRating + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetch3PLShipmentRating = async function (filters) {
  try {
    const res = await axios.get(urls.get3PLShipmentRating + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetch3PLRating = async function (clientId, filters) {
  try {
    const res = await axios.get(urls.get3PLRating + '/' + clientId + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchCategories = async function (filters) {
  try {
    const res = await axios.get(urls.getCategories + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchSubCategories = async function (categoryId, filters) {
  try {
    const res = await axios.get(urls.getSubCategories + '/' + categoryId + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchRitase = async function (filters) {
  try {
    const res = await axios.get(urls.getRitase + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchInvoiceCustomer = async function (filters) {
  try {
    const res = await axios.get(urls.getInvoiceCustomer + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchAgingReport = async function (filters) {
  try {
    const res = await axios.get(urls.getAgingReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchIncomeReport = async function (filters) {
  try {
    const res = await axios.get(urls.getIncomeReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchClientReportCsv = async function (filters) {
  try {
    const res = await axios.get(urls.getClientReportCsv + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchTaxRecap = async function (dateFrom, dateTo, customerId = null) {
  console.log('TCL: dateFrom, dateTo, customerId', dateFrom, dateTo, customerId)
  try {
    let data = {
      from: dateFrom,
      to: dateTo,
    }
    if (customerId) data.customerId = customerId
    const res = await axios.get(urls.getTaxRecap + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const transporterRatingByTransport = async function (filters) {
  try {
    const res = await axios.get(urls.getTransporterRatingByTransport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const transporterRatingByDriver = async function (filters) {
  try {
    const res = await axios.get(urls.getTransporterRatingByDriver + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}
const fetchOrderReport = async function (filters) {
  try {
    const res = await axios.get(urls.getOrderReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}
const fetchDataArmadaReport = async function (filters) {
  try {
    const res = await axios.get(urls.getDataArmadaReport + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchVehicleTypes,
  fetchCustomerDetail,
  fetchBasp,
  fetch3PLDriverRating,
  fetch3PLTransportRating,
  fetch3PLShipmentRating,
  fetch3PLRating,
  fetchCategories,
  fetchSubCategories,
  fetchRitase,
  fetchInvoiceCustomer,
  fetchTaxRecap,
  transporterRatingByTransport,
  transporterRatingByDriver,
  fetchAgingReport,
  fetchIncomeReport,
  fetchClientReportCsv,
  fetchOrderReport,
  fetchDataArmadaReport
}
